// biome-ignore lint/style/noRestrictedImports: encapsulation
import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import cssWorker from "monaco-editor/esm/vs/language/css/css.worker?worker";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import htmlWorker from "monaco-editor/esm/vs/language/html/html.worker?worker";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import jsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import tsWorker from "monaco-editor/esm/vs/language/typescript/ts.worker?worker";

import type { Monaco } from "./_monaco";

/* Required for Vite as per https://www.npmjs.com/package/@monaco-editor/react#loader-config */
self.MonacoEnvironment = {
	getWorker(_, label) {
		if (label === "json") {
			return new jsonWorker();
		}
		if (label === "css" || label === "scss" || label === "less") {
			return new cssWorker();
		}
		if (label === "html" || label === "handlebars" || label === "razor") {
			return new htmlWorker();
		}
		if (label === "typescript" || label === "javascript") {
			return new tsWorker();
		}
		return new editorWorker();
	},
};

async function loader(): Promise<typeof Monaco> {
	const [{ loader: monacoLoader }, monaco] = await Promise.all([
		// biome-ignore lint/style/noRestrictedImports: encapsulation
		import("@monaco-editor/react"),
		// biome-ignore lint/style/noRestrictedImports: encapsulation
		import("monaco-editor"),
	]);

	monacoLoader.config({ monaco });

	return monaco;
}

export { loader };
